import { ThemeContext } from 'styled-components';
import { useContext } from 'react';
import { Theme } from '../theme';

const useTheme: () => Theme = () => useContext(ThemeContext);

export default useTheme;
